import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{staticClass:"rounded-lg",staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.getImageUrl(),"contain":""},on:{"click":function($event){_vm.$router.push(_vm.getLink(_vm.blog.slugUrl))}}})}
var staticRenderFns = []

export { render, staticRenderFns }